import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useContext, useCallback } from 'react';
import _ from 'lodash';
import { Col, Layout, Row, Spin, message, Typography, Select } from 'antd';
import api from 'api';
import { get, post } from 'utils/fetch';
import OfferingTile from 'pages/Offerings/OfferingTile';
import { useLocation } from 'react-router-dom';
import { OfferingDetailed } from 'pages/Offerings/OfferingDetailed';
import { AppHeader } from 'components/AppHeader';
import { CompanyInfo } from 'components/CompanyInfo';
import { isPhoneSize } from 'utils/util';
import { GlobalContext } from 'GlobalContext';
import { getTypeBackgroundColor } from 'utils/util';
import { OfferingFilters } from 'pages/Offerings/OfferingFilters';
import { OfferingTileV2 } from 'pages/Offerings/OfferingTileV2';
import {
    useFiefAuth,
    useFiefIsAuthenticated,
    useFiefUserinfo,
} from '@fief/fief/react';
import { useLogoutHelper } from 'utils/util';

const { Text } = Typography;

// interface OfferingProps {
//     email: string | undefined;
//     basicInfo: any;
//     setEmail: any;
//     setBasicInfo: any;
// }

function Header() {
    const navigate = useNavigate();
    const [loginIsHovered, setLoginIsHovered] = useState(false);
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}
        >
            <div
                style={
                    isPhoneSize()
                        ? {
                              width: '50%',
                              alignSelf: 'center',
                              paddingLeft: '20px',
                              paddingTop: '17px',
                          }
                        : {
                              paddingLeft: '20px',
                          }
                }
            >
                <span
                    style={{
                        fontFamily: 'Archivo',
                        fontSize: '23px',
                        fontWeight: 'bold',
                        lineHeight: 'normal',
                        letterSpacing: '0em',
                        color: '#3D3D3D',
                    }}
                >
                    AlphaX{' '}
                </span>
                <br></br>
                <span
                    style={{
                        fontFamily: 'Arial',
                        fontSize: '20px',
                        fontWeight: 'normal',
                        lineHeight: 'normal',
                        letterSpacing: '0em',
                        color: '#3D3D3D',
                    }}
                >
                    Investor Portal
                </span>
            </div>
            <button
                style={{
                    background: loginIsHovered
                        ? 'rgb(64, 150, 255)'
                        : '#1777FF',
                    color: 'white',
                    width: '60px',
                    height: '30px',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    marginTop: '10px',
                    border: 'none',
                    alignSelf: 'center',
                    marginRight: isPhoneSize() ? '20px' : '',
                }}
                onClick={() => navigate('/home')}
                onMouseEnter={() => setLoginIsHovered(true)}
                onMouseLeave={() => setLoginIsHovered(false)}
            >
                Login
            </button>
            {/* <div onClick={() => navigate('/home')}>Login</div> */}
        </div>
    );
}

export function Main() {
    const location = useLocation();
    const { logout } = useLogoutHelper();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const isAuthenticated = useFiefIsAuthenticated();
    //route to / if not authenticated
    useEffect(() => {
        if (!isAuthenticated) return;
        console.log('Logging out user to view offerings');
        logout();
    }, []);
    sessionStorage.setItem('url', '/');
    //---------------------------
    //console.log("Offering id:", id)

    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(true);
    const [funds, setFunds] = useState([]);
    const [nameidMapping, setNameIDMapping] = useState({});
    const [fundTypeToView, setFundTypeToView] = useState('Both');

    function Title() {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifySelf: 'left',
                    width: isPhoneSize() ? '100%' : '',
                }}
            >
                <h1 style={{ width: '100%', paddingTop: '5px' }}>Offerings</h1>
                <OfferingFilters />
            </div>
        );
    }

    function OfferingDisplay() {
        const { offeringFilter } = useContext(GlobalContext);
        return (
            <Row
                gutter={[24, 24]}
                style={isPhoneSize() ? { justifyContent: 'center' } : {}}
            >
                {funds &&
                    funds
                        .filter((fund) => {
                            if (!fund.offering_status) {
                                return true;
                            }
                            return offeringFilter['Investment Status'].includes(
                                fund.offering_status
                            );
                        })
                        .filter((fund) => {
                            if (!fund.type) {
                                return true;
                            }
                            return fund.type
                                .split('/')
                                .some((type) =>
                                    offeringFilter['Investment Type'].includes(
                                        type.trim()
                                    )
                                );
                        })
                        .filter((fund) => {
                            if (!fund.min_investment) {
                                return true;
                            }
                            return (
                                fund.min_investment >=
                                    offeringFilter['Minimum Investment'][0] /
                                        1000 &&
                                fund.min_investment <=
                                    offeringFilter['Minimum Investment'][1] /
                                        1000
                            );
                        })
                        .filter((fund) => {
                            const term = fund.target_term;
                            const filter = offeringFilter['Term'];

                            if (!term) return true;

                            if (term <= 6 && filter.includes('0-6 Months'))
                                return true;
                            if (
                                term >= 6 &&
                                term <= 24 &&
                                filter.includes('6-24 Months')
                            )
                                return true;
                            if (term >= 24 && filter.includes('24 Months+'))
                                return true;

                            return false;
                        })
                        .sort((a, b) => {
                            if (a.name < b.name) return -1;
                            return 1;
                        })
                        .map((f, id) => (
                            <Col key={id}>
                                <OfferingTileV2
                                    fund={f}
                                    link={`/offerings?id=${f.id}`}
                                />
                            </Col>
                        ))}
            </Row>
        );
    }

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchFunds() {
        await get(api.main.offerings, setFunds, (errors) =>
            errors.forEach((err) => {
                displayErrorMessage(err.message);
            })
        );
    }

    async function fetchData() {
        await fetchFunds();
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, []);

    let content = null;

    if (loading || isAuthenticated)
        content = <Spin style={{ height: '100vh', marginTop: '30px' }} />;
    else {
        content = (
            <div
                style={
                    isPhoneSize()
                        ? {}
                        : {
                              overflowY: 'scroll',
                              overflowX: 'hidden',
                              scrollbarWidth: 'none',
                              height: 'calc(100vh - 12px)',
                              width: '100%',
                          }
                }
            >
                <Layout style={{ background: 'transparent' }}>
                    <Header />
                    <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                        <Title />
                        <OfferingDisplay />
                    </div>
                </Layout>
                <div
                    style={{ height: '50px', width: '100%', display: 'flex' }}
                ></div>
            </div>
        );
    }
    return (
        <div
            style={
                isPhoneSize()
                    ? {
                          display: 'flex',
                          flexDirection: 'column',
                          // overflowX: "hidden",
                          scrollbarWidth: 'none',
                          height: 'calc(100vh - 154px)',
                          paddingBottom: '50px',
                      }
                    : {
                          display: 'flex',
                          flexDirection: 'row',
                      }
            }
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                {id === null ? (
                    <>
                        {contextHolder}
                        {content}
                    </>
                ) : (
                    <></>
                )}
            </div>

            <div
                style={
                    isPhoneSize()
                        ? {
                              width: '100%',
                              justifyItems: 'center',
                          }
                        : {}
                }
            >
                <div
                    style={
                        isPhoneSize()
                            ? {
                                  width: '380px',
                                  textAlign: 'left',
                                  background: 'transparent',
                                  padding: 12,
                              }
                            : {
                                  width: '280px',
                                  textAlign: 'left',
                                  background: 'transparent',
                                  padding: 12,
                                  overflowY: 'scroll',
                                  overflowX: 'hidden',
                                  height: '100vh',
                                  scrollbarWidth: 'none',
                                  // height: 'calc(100vh - 144px)'
                              }
                    }
                >
                    <Row gutter={[12, 16]}></Row>

                    <CompanyInfo />
                </div>
            </div>
        </div>
    );
}
